import {useEffect, useState} from "react";
import {useApplicantStore} from "../stores/applicantStore";
import {useUserStore} from "../stores/userStore";
import {ApiService} from "../api/ApiService";
import {Applicant} from "../api/types/Applicant";

export const useApplicantCheck = (applicantId?: number | null): {
    applicant: Applicant | null,
    loading: boolean,
    refresh: (fetchApplicantId: number) => void,
    getCurrentApplicantId: () => number | undefined
} => {
    const applicantStore = useApplicantStore();
    const userStore = useUserStore();
    const [loading, setLoading] = useState<boolean>(true);

    const refresh = (fetchApplicantId: number) => {
        setLoading(true);
        ApiService.GetApplicant(fetchApplicantId).then(a => {
            if (a.success) {
                applicantStore.setApplicant(a.data);
                localStorage.setItem("lastApplicant", `${a.data.id}`);
            }
            setLoading(false);
        })
    }

    const getCurrentApplicantId = () => {
        if (applicantId) return applicantId;
        const lastApplicant = localStorage.getItem("lastApplicant");
        if (lastApplicant) {
            return parseInt(lastApplicant);
        } else {
            if (!userStore.user) return;
            return userStore.user.applicants[0]?.id;
        }

    }

    useEffect(() => {
        if (applicantId === null) return;
        let fetchApplicantId = getCurrentApplicantId();
        if (!fetchApplicantId) {
            setLoading(false);
            return;
        }

        if (applicantStore.applicant && (fetchApplicantId == applicantStore.applicant.id)) {
            setLoading(false);
            return;
        }

        refresh(fetchApplicantId);
    }, [applicantId]);

    return {applicant: applicantStore.applicant, loading, refresh, getCurrentApplicantId};
}